import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allClubs,
    addTournamentList,
 } from 'Actions';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allClubs();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            club:'', 
            seldate:'',        
            
        };
    }

    selclub = (evt) =>{
        var clubid =evt.value;
        this.setState({ club:clubid });
    }

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    addHandleSubmit(event){
        event.preventDefault();
        this.props.addTournamentList(event).then((data) => {   
        
            if(data.status==1){                    
                this.setState({ 
                    seldate:'',
                    club:'',
                 });

                document.getElementById("addform").reset();                   
            }
        });
        
    }  


render() {

    const { clublist, loading} = this.props;   

    const allclub=clublist.map((stdval) => {  
        return {
           label: stdval.ccb_clubName,  
           value: stdval.ccb_clubID
        }
    });
      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8">
                            <RctCollapsibleCard heading="Create Tournament">   
                                <div className="row float-right"> 
                                        <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                 </div>  
                                    <div className="row">                                 
                                        <div className="col-sm-12 col-md-7">   
                                            <FormGroup>
                                                <Label for="name">Name of tournament *</Label>
                                                <input type="text" name="name" id="name" className="form-control form-control-alternative" required/>
                                            </FormGroup>  
                                        </div> 
                                        <div className="col-sm-12 col-md-7">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                        <div className="col-sm-12 col-md-7">
                                                <Label for="course">Course *</Label>
                                                <FormGroup>
                                                    <Label for="course">Course *</Label>
                                                    <Selectsearch placeholder="Select the course" id="course" name="course" rules={{ required: 'Please select course'}} options={allclub} value={allclub.find(obj => obj.value === this.state.club)} onChange={this.selclub} required/>
                                                </FormGroup>
                                        </div>  
                                        <div className="col-sm-12 col-md-7">   
                                            <FormGroup>
                                                <Label for="country">Country *</Label>
                                                <input type="text" name="country" id="country" className="form-control form-control-alternative" required/>
                                            </FormGroup>  
                                        </div>
                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />     
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { clublist, loading } = mostlyused;
    return { clublist, loading };
   
}


export default connect(mapStateToProps, {
    allClubs,
    addTournamentList,
})(AddItems);
